import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-48c32126"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "px-2 pb-2" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "\n        勤務開始時刻まで1時間以上あるため、出勤処理を行うことができません\n      ", -1))
const _hoisted_3 = { class: "my-4" }
const _hoisted_4 = { class: "w-100" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("colgroup", null, [
  /*#__PURE__*/_createElementVNode("col", { class: "label-cell" }),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createElementVNode("col")
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "勤務開始時刻", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "出勤処理可能時刻", -1))

import { computed } from "vue";
import type { PropType } from "vue";
import AppButton from "@/components/atoms/button/AppButton.vue";
import { Application } from "@/types/order/Application";
import {
  formatFromISOString,
  formatFromUnixTimestamp,
  parseISO,
  subHours,
} from "@/utils/date";


export default /*#__PURE__*/_defineComponent({
  __name: 'NotStartWorkModal',
  props: {
  visible: {
    type: Boolean,
    default: false
  },
  application: {
    type: Object as PropType<Application>,
    required: true
  }
},
  emits: ["close"],
  setup(__props, { emit: emits }) {

const props = __props;



const displayCanStartWorkTime = computed(() => {
  return `${formatFromUnixTimestamp(
    subHours(parseISO(props.application.appliedStartWorkAt), 1),
    "MM/dd(E) HH:mm"
  )}`;
});

const displayStartWorkTime = computed(() => {
  return `${formatFromISOString(
    props.application.appliedStartWorkAt,
    "MM/dd(E) HH:mm"
  )}`;
});



function onClose() {
  emits("close");
}

return (_ctx: any,_cache: any) => {
  const _component_BModal = _resolveComponent("BModal")!

  return (_openBlock(), _createBlock(_component_BModal, {
    visible: __props.visible,
    "hide-header": "",
    "hide-footer": "",
    centered: "",
    onHide: onClose
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createTextVNode(),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("table", _hoisted_4, [
            _hoisted_5,
            _createTextVNode(),
            _createElementVNode("tr", null, [
              _hoisted_6,
              _createTextVNode(),
              _createElementVNode("td", null, _toDisplayString(displayStartWorkTime.value), 1)
            ]),
            _createTextVNode(),
            _createElementVNode("tr", null, [
              _hoisted_7,
              _createTextVNode(),
              _createElementVNode("td", null, _toDisplayString(displayCanStartWorkTime.value), 1)
            ])
          ])
        ]),
        _createTextVNode(),
        _createVNode(AppButton, {
          block: "",
          onClick: onClose
        }, {
          default: _withCtx(() => [
            _createTextVNode("\n        確認しました\n      ")
          ], undefined, true),
          _: 1
        })
      ])
    ], undefined, true),
    _: 1
  }, 8, ["visible"]))
}
}

})